import axios from '@/libs/api.request'

export const GetScreenSaver = data => {
  return axios.request({
    url: '/print/screen',
    params: data,
    method: 'get'
  })
}
export const ScreenSaverUpload = data => {
  return axios.request({
    url: '/print/screen/upload',
    data,
    method: 'post'
  })
}
export const SaveScreenSaver = data => {
  return axios.request({
    url: '/print/screen',
    data,
    method: 'put'
  })
}
export const GetScreenSaverInfo = data => {
  return axios.request({
    url: '/print/screen/info',
    params: data,
    method: 'get'
  })
}
export const ScreenBind = data => {
  return axios.request({
    url: '/print/screen/bind',
    data,
    method: 'put'
  })
}
